module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-english.18e4bd25.jpg";